module.exports = __webpack_public_path__ + "static/media/IBM.fa3ef1f1.png";